module.exports = __webpack_public_path__ + "assets/images/14cd1d69d717a3dd8f7fa37131b2ca93.svg";